<script>
    import { createEventDispatcher } from 'svelte'

    let searchTimer = null
    
    const dispatch = createEventDispatcher ();

    const onSearchInput = (event) => {
        const { value } = event.target

        if (searchTimer) {
            clearTimeout (searchTimer)
            searchTimer = null
        }

        searchTimer = setTimeout (() => {
            dispatch ('search', value)
        }, 400)
    }
</script>

<style>
    .SearchQuery {
        display: block;
        width: 100%;
        background-color: var(--sidelink-hover);
        /* line-height: 28px; */
        /* font-weight: 600;
        font-size: 14px; */
        text-align: left;
        border-radius: 3px;
        position: relative;
        height: 29px;
        /* line-height: 29px; */
        padding: 0 0 0 15px;
    }
    .SearchQuery input {
        position: absolute;
        left: 0;
        top: 0;
        color: var(--forge-primary-fg);
        /* font-weight: 600; */
        padding: 4px 15px 4px 15px;
        border: none;
        margin-bottom: 0;
        outline: none;
        width: 100%;
        background-color: unset;
    }
</style>

<div class="SearchQuery">
    <input type="text" value="" placeholder="Cerca" on:input={onSearchInput} />
</div>